import api from '@/shared/api/api-client';

import type { ApiKey } from '../../_shared/domain/api-key.model';
import type { ApiKeyDraft } from '../domain/api-key-draft.model';
import type { EditApiKeyGateway } from './edit-api-key.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Edit API key endpoints and body mapping (kept 1:1 with the original
 * `EditApiKey` page's `/api-keys/:id` GET + PATCH). A failed load (e.g. 404)
 * rejects and is handled by the saga, which drives the redirect.
 */
export const httpEditApiKeyGateway: EditApiKeyGateway = {
  loadApiKey: (id: string) => api.get<ApiKey>(`/api-keys/${id}`),
  updateApiKey: async (id: string, draft: ApiKeyDraft) => {
    await api.patch(`/api-keys/${id}`, {
      name: draft.name.trim(),
      scopes: draft.scopes,
      status: draft.status,
    });
  },
};
